// Module
var code = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"8\" height=\"6\" viewBox=\"0 0 8 6\"><path fill-rule=\"evenodd\" d=\"M4.119 3.87L1.139.89a.5.5 0 00-.707.708l2.98 2.98H3.41l.708.708v-.001h.001l.708-.707 2.979-2.98a.502.502 0 000-.708.5.5 0 00-.707 0l-2.98 2.98z\"/></svg> ";
// Exports
module.exports = code;